/**
 * @fileoverview JavaScript to support the Branding tab in the Partner Portal.
 *
 * See com.yext.resellers.app.controllers.CoBranding and its associated views.
 */
goog.module('yext.resellers.cobranding');

goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');

/**
 * Makes a click handler that shows the dialog for uploading a new logo.
 *
 * TODO(eefi): The extraction of this function is temporary and should probably
 * be reversed when the rest of
 * src/com/yext/resellers/public/javascript/cobranding.js is migrated.
 *
 * @param {function(Object)} sendLogoUpdate
 * @return {function(jQuery.Event)}
 */
const makeChangeLogoClickHandler = function(sendLogoUpdate) {
  return function(e) {
    yext.dam.assetselector.has.DAM = false;
    yext.dam.assetselector.showLoaderOnly(yext.dam.assetselector.types.PHOTO);

    $(yext.dam.assetselector.events)
      .off('added.assetselector')
      .on('added.assetselector', function(e, asset) {
        sendLogoUpdate(asset);
      });
  };
};

goog.exportSymbol(
  'yext.resellers.cobranding.makeChangeLogoClickHandler',
  makeChangeLogoClickHandler);
